import { ApiService } from '~/services/api/api'
import type { Candidate } from '~/types/Candidate'
import type { Unsaved } from '~/types/Unsaved'

export class CandidateService {
  private readonly apiService = new ApiService()

  async upsertCandidate(candidateData: Unsaved<Candidate>) {
    const response = await this.apiService.post<Candidate, Unsaved<Candidate>>(
      '/candidates',
      candidateData,
      {
        useFallbackAuth: true,
      },
    )
    return response
  }

  async upsertCandidateWithLtiUserId(
    candidateData: Unsaved<Candidate>,
    ltiUserId: string,
  ) {
    const response = await this.apiService.post<
      Candidate,
      Unsaved<Candidate> & { ltiUserId: string }
    >(
      '/candidates',
      { ...candidateData, ltiUserId },
      {
        useFallbackAuth: true,
      },
    )
    return response
  }

  async getCandidateById(candidateId: string) {
    const response = await this.apiService.get<Candidate>(
      `/candidates/${candidateId}`,
      {
        useFallbackAuth: true,
      },
    )
    return response
  }
}
